<template>
  <div class="marco">
    <div class="d-flex justify-content-between">
      <div class="country d-flex align-items-center">
        <IconComponent name="alertCircle" />
        <div class="d-flex align-items-center flex-wrap">
          <h3>{{ itemsData && itemsData[0]?.country?.name }}&nbsp;</h3>
          <span v-if="itemsData && itemsData[0]?.country?.countryGroupId === 7">- член союза ЕАЭС</span>
        </div>
      </div>
      <div class="analytics-source-text">Источник: Всемирный банк</div>
    </div>
    <div class="d-flex align-items-center">
      <div class="country d-flex align-items-center mr-4">
        <IconComponent name="userIcon" />
        <h3>Население&nbsp;</h3>
        <span v-if="population && population.length"
          >-
          {{ getLastItem(population)?.value.toLocaleString() }}
          человек ({{ getLastItem(population)?.year }} г.)
        </span>
      </div>
      <!--      <div class="country d-flex align-items-center">-->
      <!--        <icon-component name="award" />-->
      <!--        <h3>Позиция в рейтинге стран мира по размеру ВВП &nbsp;</h3>-->
      <!--        <span>- 1 место</span>-->
      <!--      </div>-->
    </div>
    <div class="key-indicators__inner">
      <SectionTitle text="Ключевые показатели" class="key-indicators__title" />
      <ul class="key-indicators">
        <li
          v-for="card in keyIndicators"
          :key="card.selectId"
          @click="card.moreInfoVisible ? selectIndicator(card.selectId, card.selectText) : null"
          class="key-indicators__item"
          :class="{ 'more-info-hidden': !card.moreInfoVisible }"
        >
          <div class="key-indicators__item--text">
            <div>
              <p>
                <template v-for="(line, index) in card.titleLines" :key="index">
                  {{ line }}<br v-if="index < card.titleLines.length - 1" />
                </template>
              </p>
              <p>
                Источник:
                <br />
                {{ card.source }}
              </p>
            </div>

            <p>
              {{ card.year }} г.
              <template v-if="card.showPeriodDescription">{{ getPeriodDescription(card.year) }}</template>
            </p>
          </div>

          <div class="key-indicators__item-wrapper" :class="{ active: selectTypeId === card.activeId }">
            <i v-if="card.trend === 'down'" class="fas fa-solid mr-1 text-red fa-arrow-down"></i>
            <i v-if="card.trend === 'up'" class="fas fa-solid mr-1 text-green fa-arrow-up"></i>
            <strong>{{ card.value }}</strong>
            <p>{{ card.unit }}</p>
          </div>
          <button class="btn-default" v-if="card.moreInfoVisible">
            <IconComponent name="chartIcon" />Больше информации
          </button>
        </li>
      </ul>
    </div>
    <h2 class="mb-3 mt-5">{{ indicatorText }}</h2>
    <EChartsVerticalBar
      v-if="selectTypeId"
      :key="selectTypeId"
      :formatLabel="formatLabel"
      :formatLabelFunction="formatChartAxisLabel"
      :labels="itemsDataYears"
      :dataset="macroEconChartDataset"
      :height="400"
      :legendSelectable="false"
      :showSeriesLabel="showMacroChartSeriesLabel"
    />
    <SectionTitle text="Другие показатели" class="mb-3 mt-5" />
    <div class="d-flex align-items-start">
      <div class="indicators">
        <IconComponent name="UserIcons" />
        <p>Безработица</p>
        <p>
          {{ getLastItem(unemploymentRate)?.year }} г.
          {{ getPeriodDescription(getLastItem(unemploymentRate)?.year) }}
        </p>
        <p v-if="unemploymentRate?.length > 0">
          <strong>{{ getLastItem(unemploymentRate)?.value }}%</strong>
        </p>
        <p v-else>
          <strong>-</strong>
        </p>
        <div class="key-indicators__item">
          <p>
            Источник:
            <br />
            Всемирный банк
          </p>
        </div>
      </div>
      <div class="indicators" v-if="realIncome">
        <IconComponent name="moneyIcon" />
        <p>Реальные располагаемые доходы населения</p>
        <p>Период: {{ realIncome.year }} {{ getPeriodDescription(realIncome.year) }}</p>
        <p>
          <strong>{{ formatNumber(realIncome.value, 1) }}</strong>
        </p>
        <p>{{ realIncome.unit }}</p>
      </div>
    </div>
    <SectionTitle text="Структура ВДС, % от ВВП" class="mb-3 mt-5" />
    <div class="key-indicators__item">
      <p class="text-align-left">
        Источник:
        <br />
        Всемирный банк
      </p>
      <p class="text-align-left" v-if="gdpYear > 0">Период: {{ gdpYear }} г.</p>
    </div>
    <template v-if="gdpStructure">
      <EChartsHorizontalBar
        :showLegend="false"
        :valueFractionDigits="1"
        :barMaxWidth="20"
        formatLabel=" %"
        :labels="gdpStructure.labels"
        :dataset="[
          {
            data: gdpStructure.values.map(Number),
            colors: ['#0093BA', '#5bc6e3', '#337280', '#96d2e7'],
          },
        ]"
      />
    </template>
  </div>
</template>

<script>
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import Constants from '@/common/constants';
  import text from '@/common/mixins/text';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import { getLastItem } from '@/common/utils/array';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import IndicatorApi from '@/modules/admin/api/indicatorVisibility';
  import Api from '@/modules/countryАnalytics/api';

  import getPeriodDescription from '../../utils/period';

  export default {
    name: 'MacroEcon',
    components: {
      SectionTitle,
      EChartsHorizontalBar,
      EChartsVerticalBar,
      IconComponent,
    },
    mixins: [text],
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        selectTypeId: null,
        indicatorText: '',
        itemsData: null,
        gdpStructure: null,
        gdpYear: 0,
        formatLabel: ' $ млрд',
        currYear: new Date().getFullYear(),
        realIncome: null,

        gdpMoreInfo: true,
        capitaGdpMoreInfo: true,
        industryGdpMoreInfo: true,
        importsGdpMoreInfo: true,
        influationGdpMoreInfo: true,
        gdpPPSMoreInfo: true,
        gdpGrowMoreInfo: true,
        gdpGrowForecastMoreInfo: true,
      };
    },
    created() {
      this.loadIndicatorVisibility();
      this.loadPage();
    },
    methods: {
      getPeriodDescription,
      loadIndicatorVisibility() {
        IndicatorApi.search().then((response) => {
          this.gdpMoreInfo = response.data[0].moreInfoVisible;
          this.capitaGdpMoreInfo = response.data[1].moreInfoVisible;
          this.industryGdpMoreInfo = response.data[2].moreInfoVisible;
          this.importsGdpMoreInfo = response.data[3].moreInfoVisible;
          this.influationGdpMoreInfo = response.data[4].moreInfoVisible;
          this.gdpPPSMoreInfo = response.data[5].moreInfoVisible;
          this.gdpGrowMoreInfo = response.data[6].moreInfoVisible;
          this.gdpGrowForecastMoreInfo = response.data[7].moreInfoVisible;
        });
      },
      selectIndicator(id, text) {
        this.selectTypeId = id;
        this.indicatorText = text;
      },
      formatChartAxisLabel(value) {
        return this.formatNumber(Number(value), 1);
      },
      getLastItem,
      buildKeyIndicator(data, options) {
        const last = this.getLastItem(data);
        const prev = this.getLastItem(data, 1);

        let trend = null;
        if (last && prev) {
          if (+last.rawValue > +prev.rawValue) trend = 'up';
          else if (+last.rawValue < +prev.rawValue) trend = 'down';
        }

        return {
          ...options,
          year: last?.year,
          value: data?.length > 0 ? last?.value : '-',
          trend,
        };
      },
      loadPage() {
        Api.searchMacro({
          countryId: this.countryId,
        }).then((res) => {
          this.itemsData = res.data.items;
          let gdpStruct = this.itemsData
            .filter((x) => x.macroeconomicIndicatorId >= 13 && x.macroeconomicIndicatorId <= 16)
            .sort(this.sortByYear)
            .sort((a, b) => a.value - b.value);

          this.gdpYear = Math.max.apply(
            Math,
            gdpStruct.map(function (o) {
              return o.year;
            }),
          );
          gdpStruct = gdpStruct.filter((x) => x.year == this.gdpYear);

          this.gdpStructure = null;
          this.$nextTick(() => {
            this.gdpStructure = {
              labels: gdpStruct.map((x) => x.macroeconomicIndicator.title),
              values: gdpStruct.map((x) => x.value.toFixed(1)),
            };
          });

          this.processGdpGrowForecast();
          this.processGdpGrow();
        });
        Api.getRealIncome(this.countryId).then((response) => {
          this.realIncome = response.data;
        });
      },
      processGdpGrowForecast() {
        let resultItems =
          this.itemsData &&
          this.itemsData
            ?.filter((item) => {
              return item?.macroeconomicIndicatorId === 17 && item.year > 2009;
            })
            .sort(this.sortByYear);

        if (resultItems) {
          for (let i = resultItems.length - 1; i > 0; i--) {
            resultItems[i].value = ((resultItems[i].value - resultItems[i - 1].value) * 100) / resultItems[i - 1].value;
          }
          resultItems[0].value = 0;
        }
      },
      processGdpGrow() {
        this.itemsData = this.itemsData?.filter((item) => {
          return item.macroeconomicIndicatorId != 7;
        });

        let resultItems =
          this.itemsData &&
          this.itemsData
            ?.filter((item) => {
              return item?.macroeconomicIndicatorId === 2 && item.year > 2009;
            })
            .sort(this.sortByYear)
            .map((item) => ({
              year: item.year,
              value: item.value,
              macroeconomicIndicatorId: 7,
              countryId: item.countryId,
              country: item.country,
              macroeconomicIndicator: item.macroeconomicIndicator,
            }));

        if (resultItems) {
          for (let i = resultItems.length - 1; i > 0; i--) {
            resultItems[i].value = ((resultItems[i].value - resultItems[i - 1].value) * 100) / resultItems[i - 1].value;
          }
          resultItems[0].value = 0;
        }

        this.itemsData = this.itemsData.concat(resultItems);
      },
      sortByYear(x, y) {
        if (x.year < y.year) {
          return -1;
        }
        if (x.year > y.year) {
          return 1;
        }
        return 0;
      },
    },
    computed: {
      keyIndicators() {
        return [
          this.buildKeyIndicator(this.gdp, {
            titleLines: ['ВВП в текущих ценах'],
            source: 'Всемирный банк',
            unit: 'млрд $ США',
            selectId: 2,
            selectText: 'ВВП в текущих ценах, млрд $ США',
            activeId: 2,
            moreInfoVisible: this.gdpMoreInfo,
            showPeriodDescription: true,
            showSeriesLabel: false,
          }),
          this.buildKeyIndicator(this.capitaGdp, {
            titleLines: ['ВВП на душу населения', '(в текущих ценах)'],
            source: 'Всемирный банк',
            unit: '$ США',
            selectId: 5,
            selectText: 'ВВП на душу населения, $ США',
            activeId: 5,
            moreInfoVisible: this.capitaGdpMoreInfo,
            showPeriodDescription: true,
            showSeriesLabel: false,
          }),
          this.buildKeyIndicator(this.gdpPPS, {
            titleLines: ['ВВП по ППС', '(в текущих ценах)'],
            source: 'Всемирный банк',
            unit: 'млрд $ США',
            selectId: 11,
            selectText: 'ВВП по ППС (в текущих ценах), млрд $ США, (международный доллар)',
            activeId: 11,
            moreInfoVisible: this.gdpPPSMoreInfo,
            showPeriodDescription: true,
            showSeriesLabel: false,
          }),
          this.buildKeyIndicator(this.gdpGrow, {
            titleLines: ['Темп прироста ВВП', '(в постоянных ценах)'],
            source: 'Международный валютный фонд',
            unit: '%',
            selectId: 18,
            selectText: 'Темп прироста ВВП (в постоянных ценах), %',
            activeId: 7,
            moreInfoVisible: this.gdpGrowMoreInfo,
            showPeriodDescription: true,
          }),
          this.buildKeyIndicator(this.gdpGrowForecast, {
            titleLines: ['Прогноз темпа прироста ВВП', '(в постоянных ценах)'],
            source: 'Международный валютный фонд',
            unit: '%',
            selectId: 19,
            selectText: 'Прогноз темпа прироста (в постоянных ценах), %',
            activeId: 19,
            moreInfoVisible: this.gdpGrowForecastMoreInfo,
            showPeriodDescription: false,
          }),
        ];
      },
      // население
      population() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 1 && item.year <= this.currYear)
            .sort(this.sortByYear)
        );
      },
      gdp() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 2 && item.year > 2010 && item.year <= this.currYear)
            .sort(this.sortByYear)
            .map((item) => ({
              year: item.year,
              rawValue: item.value,
              value: this.formatNumber(item.value / (Constants.MILLION * Constants.THOUSAND), 1),
            }))
        );
      },
      capitaGdp() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 5 && item.year <= this.currYear)
            .sort(this.sortByYear)
            .map((item) => ({ year: item.year, rawValue: item.value, value: this.formatNumber(item.value, 1) }))
        );
      },
      gdpGrow() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 18 && item.year <= this.currYear)
            .sort(this.sortByYear)
            .map((item) => ({ year: item.year, rawValue: item.value, value: this.formatNumber(item.value, 1) }))
        );
      },
      unemploymentRate() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 10 && item.year <= this.currYear)
            .sort(this.sortByYear)
            .map((item) => ({ year: item.year, rawValue: item.value, value: this.formatNumber(item.value, 1) }))
        );
      },
      gdpPPS() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 11 && item.year <= this.currYear)
            .sort(this.sortByYear)
            .map((item) => ({
              year: item.year,
              rawValue: item.value,
              value: this.formatNumber(item.value / (Constants.MILLION * Constants.THOUSAND), 1),
            }))
        );
      },
      gdpGrowForecast() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => item?.macroeconomicIndicatorId === 19 && item.year <= this.currYear + 1)
            .sort(this.sortByYear)
            .map((item) => ({ year: item.year, rawValue: item.value, value: this.formatNumber(item.value, 1) }))
        );
      },
      itemsDataValue() {
        const formatting = (item) => {
          switch (this.selectTypeId) {
            case 2:
            case 11:
              this.formatLabel = ' млрд $ США';
              return (item.value / (Constants.MILLION * Constants.THOUSAND)).toFixed(1);
            case 5:
              this.formatLabel = ' $ США';
              return item.value.toFixed(1);
            case 3:
            case 4:
            case 6:
            case 7:
            case 17:
            case 18:
            case 19:
              this.formatLabel = ' %';
              return item.value.toFixed(1);
            default:
              return item.value.toFixed(1);
          }
        };

        return (
          this.itemsData &&
          this.itemsData
            ?.filter((item) => {
              return (
                item?.macroeconomicIndicatorId === this.selectTypeId &&
                item.year > 2009 &&
                (this.selectTypeId != 18 || item.year <= this.currYear)
              );
            })
            .sort((x, y) => {
              if (x.year < y.year) {
                return -1;
              }
              if (x.year > y.year) {
                return 1;
              }
              return 0;
            })
            .map((item) => formatting(item))
        );
      },
      itemsDataYears() {
        return (
          this.itemsData &&
          this.itemsData
            ?.filter(
              (item) =>
                item?.macroeconomicIndicatorId === this.selectTypeId &&
                item.year > 2009 &&
                (this.selectTypeId != 18 || item.year <= this.currYear),
            )
            .sort((x, y) => {
              if (x.year < y.year) {
                return -1;
              }
              if (x.year > y.year) {
                return 1;
              }
              return 0;
            })
            .map((item) => item.year)
        );
      },
      itemColors() {
        return (
          this.itemsData &&
          this.itemsData
            .filter((item) => item?.macroeconomicIndicatorId === this.selectTypeId && item.year > 2009)
            .map((x) => (x.year <= this.currYear ? '#0093BA' : '#96d2e7'))
        );
      },
      macroEconChartDataset() {
        return [
          {
            label: '',
            data: (this.itemsDataValue || []).map((value) => Number(value)),
            colors: this.itemColors || [],
          },
        ];
      },
      showMacroChartSeriesLabel() {
        const activeIndicator = this.keyIndicators.find((card) => card.selectId === this.selectTypeId);
        return activeIndicator?.showSeriesLabel ?? true;
      },
    },
    watch: {
      countryId() {
        this.loadPage();
      },
    },
  };
</script>

<style scoped lang="scss">
  @import './src/assets/theme/default/colors';
  .table-container {
    border-radius: 16px;
    background-color: #ffffff;
    width: 100%;
    box-shadow: 0px 0px 17px rgba(55, 55, 55, 0.08);
    overflow: auto;
    table {
      min-width: 1180px;
      &.stockTable {
        thead {
          th {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #787f8f;
            padding: 16px;
            border-bottom: 2px solid $green;
            div {
              font-weight: 500;
              font-size: 12px;
              line-height: 16px;
              color: #787f8f;
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid #d8d8d8;
          }
          td {
            padding: 16px;
            font-size: 12px;
            line-height: 18px;
            color: #535353;
            p {
              margin-bottom: 0px;
            }
          }
          button {
            margin-top: 12px;
          }
        }
      }
      &.blueGrayTable {
        thead {
          th {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #231f20;
            padding: 16px;
            background-color: #d3dfe5;
            border-bottom: 1px solid #787f8f;
            &:not(:last-of-type) {
              border-right: 1px solid #787f8f;
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid #787f8f;
            &:nth-of-type(even) {
              background-color: #f0f9ff;
            }
          }
          td {
            padding: 16px;
            font-size: 12px;
            line-height: 18px;
            color: #231f20;
            &:not(:last-of-type) {
              border-right: 1px solid #787f8f;
            }
            p {
              margin-bottom: 0px;
            }
          }
          .green {
            font-weight: 600;
            color: $green;
            border-bottom: 1px dashed $green;
            width: min-content;
          }
          .red {
            font-weight: 600;
            color: #eb5757;
          }
        }
      }
    }
  }
  .table-inner {
    min-width: 640px;
    width: 100%;
    margin-top: 12px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: $dark;
    .active {
      background-color: #ededed;
    }
    th {
      padding-bottom: 16px;
    }
    th:nth-child(1),
    td:nth-child(1) {
      padding-left: 12px;
    }
  }
  .table-custom {
    border: none;
    border-collapse: collapse;
    border: 0;
    th {
      padding: 13px 11px;
      background-color: #ffffff;
    }
    th,
    td {
      outline: var(--border);
      padding: 8px;
      text-align: center;
      font-family: 'Fira Sans', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 160%;
      color: #000000;
    }
    th:first-child,
    td:first-child {
      padding: 8px 14px 8px 8px;
      text-align: left;
    }
    //tr:nth-child(odd) {
    //  background-color: #e5f5ff;
    //}
    th {
      border-bottom: 1px solid $green !important;
    }
  }
  .table-custom-two {
    thead {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 111;
    }
  }
  .indicators {
    &:not(:last-child) {
      margin-right: 20%;
    }
    p {
      text-align: center;
      margin: 1rem 0;
      max-width: 200px;
      font-family: 'Fira Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 113.9%;

      color: #333333;
      strong {
        font-family: 'Fira Sans', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 113.9%;
        text-align: center;
      }
    }
  }
  .key-indicators {
    padding: 0 15px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    // gap: 60px 14%;
    &__item {
      cursor: pointer;
      margin-bottom: 16px;

      &--text {
        min-height: 104px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .award {
        margin-top: 12px;
      }
      &-wrapper.active {
        background: #ffffff;
        box-shadow: 0 0 17px rgba(1, 120, 200, 0.5);
        border-radius: 5px;
        p {
          color: $dark;
        }
      }
      max-width: 160px;
      width: 100%;
      p {
        margin-bottom: 4px;
        font-family: 'Fira Sans', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 113.9%;
        text-align: center;
        color: #787f8f;
      }
      &-wrapper {
        justify-content: center;
        p {
          margin: 0;
          font-family: 'Fira Sans', sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 10px;
          line-height: 12px;
          text-align: center;
          color: #787f8f;
        }
        strong {
          margin-right: 10px;
          font-family: 'Fira Sans', sans-serif;
          font-style: normal;
          font-weight: 700;
          font-size: 18px;
          line-height: 22px;
          text-align: center;
          color: #787f8f;
          white-space: nowrap;
        }
        padding: 16px;
        display: flex;
        align-items: center;
        background: #ffffff;
        box-shadow: 0 0 17px rgba(55, 55, 55, 0.08);
        border-radius: 5px;
      }
      button {
        .icon {
          margin-right: 8px;
        }
        max-width: 100px;
        font-family: 'Fira Sans', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 8px;
        line-height: 113.9%;
        text-align: center;
        color: #787f8f;
        display: flex;
        align-items: center;
        margin: -8px auto auto auto;
        padding: 8px 16px;
        border: none;
        background: #ffffff;
        box-shadow: 0 0 17px rgba(55, 55, 55, 0.08);
        border-radius: 5px;
      }
    }
    margin-top: 40px;
  }
  h2 {
    font-family: 'Fira Sans', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
  }
  h3 {
    font-family: 'Fira Sans', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
  }
  .country {
    margin-bottom: 20px;

    p {
      font-family: 'Fira Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
    }
    .icon {
      margin-right: 6px;
    }
  }
  .more-info-hidden {
    padding-bottom: 26px;
  }
</style>
